export const PRODUCT_DETAIL_ROUTE = 'package-product/pages/detail/detail'
export const PRODUCT_DETAIL_PATH = `/${PRODUCT_DETAIL_ROUTE}`
export const FLASH_PRODUCT_DETAIL_ROUTE = 'package-product/pages/flash-detail/flash-detail'
export const FLASH_PRODUCT_DETAIL_PATH = `/${FLASH_PRODUCT_DETAIL_ROUTE}`

export const CATEGORY_ROUTE = 'package-activities/pages/category/category'
export const CATEGORY_PATH = `/${CATEGORY_ROUTE}`
export const FLASH_CATEGORY_ROUTE = 'package-activities/pages/flash-category/flash-category'
export const FLASH_CATEGORY_PATH = `/${FLASH_CATEGORY_ROUTE}`

export const isProductDetailRoute = route => route === PRODUCT_DETAIL_ROUTE || route === FLASH_PRODUCT_DETAIL_ROUTE

export const isCategoryRoute = route => route === CATEGORY_ROUTE || route === FLASH_CATEGORY_ROUTE

export const resolveProductDetailPath = query => Number(query?.usage) === 2 ? FLASH_PRODUCT_DETAIL_PATH : PRODUCT_DETAIL_PATH

const getQueryValue = (queryString, targetKey) => {
  if (!queryString || !targetKey) return ''
  const queryList = queryString.split('&')
  for (const queryItem of queryList) {
    if (!queryItem) continue
    const [rawKey, ...valueParts] = queryItem.split('=')
    const key = decodeURIComponent(rawKey || '')
    if (key !== targetKey) continue
    return decodeURIComponent(valueParts.join('=') || '')
  }
  return ''
}

export const buildProductDetailQuery = query => Object.keys(query)
  .filter(key => query[key] !== undefined && query[key] !== null && query[key] !== '')
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
  .join('&')

export const buildProductDetailRouteQuery = (prod = {}, fallbackQuery = {}) => {
  const prodUsage = Number(prod?.usage)
  const fallbackUsage = Number(fallbackQuery?.usage) === 2 ? 2 : 1
  const usage = prodUsage === 1 || prodUsage === 2 ? prodUsage : fallbackUsage
  const stationId = prod?.stationId ?? fallbackQuery?.stationId
  const query = {
    ...fallbackQuery,
    spuId: prod?.spuId ?? fallbackQuery?.spuId,
    usage
  }
  if (Number(prod?.prodType) === 2 || Number(fallbackQuery?.prodType) === 2 || stationId) {
    query.prodType = 2
    query.stationId = stationId
  }
  const seckillId = prod?.spuActivity?.sekillActivitySpuVO?.seckillId || prod?.seckillId || fallbackQuery?.seckillId
  if (seckillId) {
    query.seckillId = seckillId
  }
  return query
}

export const toProductDetailUrl = query => {
  if (!query) return PRODUCT_DETAIL_PATH
  if (typeof query === 'string') {
    const normalizedQuery = query.startsWith('?') ? query.slice(1) : query
    const usage = getQueryValue(normalizedQuery, 'usage')
    const path = resolveProductDetailPath({ usage })
    return normalizedQuery ? `${path}?${normalizedQuery}` : path
  }
  const path = resolveProductDetailPath(query)
  const queryString = buildProductDetailQuery(query)
  return queryString ? `${path}?${queryString}` : path
}
